import React from 'react';
import { Container, Typography } from '@mui/material';
import HeaderEntreprise from '../header/headerEntreprise';
import HeaderRec from '../header/headerRec';
import Sidebar from '../Admin/Sidebar/Sidebar';
import Header from '../header/header';

const NotFound404 = () => {
  const rawRole = localStorage.getItem('userType') || 'invité';
  const role = rawRole.toLowerCase();

  const renderHeader = () => {
    switch (role) {
      case 'entreprise':
        return <HeaderEntreprise />;
      case 'recruteur':
        return <HeaderRec />;
      case 'invité':
        return <Header />;
      case 'admin':
      case 'commercial':
      case 'agent':
        return (
          <Sidebar
            activeItem=""
            setActiveItem={() => {}}
            mobileOpen={false}
            handleDrawerToggle={() => {}}
          />
        );
      default:
        return null;
    }
  };

  return (
    <>
      {renderHeader()}
      <Container style={{ padding: '2rem', textAlign: 'center' }}>
        <Typography variant="h3" gutterBottom>
          404 - Page introuvable
        </Typography>
        <Typography variant="body1">
          La ressource que vous cherchez n'existe pas ou a été supprimée.
        </Typography>
      </Container>
    </>
  );
};

export default NotFound404;
